module.exports = __webpack_public_path__ + "img/modelIcon_dy.5cffdd71.png";